import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import StatusPill from "./StatusPill";

export default function OrderRow({ order }) {
  return (
    <Link
      to={`/dashboard/orders/${order.id}`}
      className="block border border-white/10 p-5 md:p-6 hover:border-[#2A5BFF] transition-colors -mt-px"
      data-testid={`order-row-${order.id}`}
    >
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <div className="text-[10px] tracking-[0.28em] uppercase text-white/40">
            {new Date(order.created_at).toLocaleDateString()}
          </div>
          <div className="font-anton uppercase text-2xl md:text-3xl mt-1 leading-none">{order.service_title}</div>
          <div className="mt-3 flex flex-wrap items-center gap-3 text-[10px] tracking-[0.24em] uppercase text-white/60">
            <span data-testid={`order-payment-${order.id}`}>Payment confirmed · {(order.currency || "").toUpperCase()} {Number(order.amount).toFixed(2)}</span>
            {order.coach_name && <span data-testid={`order-coach-${order.id}`}>Coach · {order.coach_name}</span>}
            {order.estimated_turnaround && <span data-testid={`order-turnaround-${order.id}`}>ETA · {order.estimated_turnaround}</span>}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <StatusPill status={order.workspace_status} testid={`order-status-${order.id}`} />
          <ArrowUpRight size={20} className="text-white/40" />
        </div>
      </div>
    </Link>
  );
}
